module.exports = __webpack_public_path__ + "img/s6.86af0728.png";